import script from "./PopupAdaugareDetaliu.vue?vue&type=script&lang=ts&setup=true"
export * from "./PopupAdaugareDetaliu.vue?vue&type=script&lang=ts&setup=true"

import "./PopupAdaugareDetaliu.vue?vue&type=style&index=0&id=2a0fa91e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a0fa91e"]])

export default __exports__